import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07522ac8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "breadcrumbs" }
const _hoisted_2 = { class: "breadcrumbs_list" }
const _hoisted_3 = {
  key: 1,
  class: "breadcrumbs_list_item_current"
}

import { PropType } from 'vue';
export type Breadcrumbs = {
  label: string;
  name?: string;
  params?: object;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'Breadcrumbs',
  props: {
  breadcrumbs: {
    type: Array as PropType<Breadcrumbs[]>,
    default() {
      return [];
    },
  },
},
  setup(__props) {

const props = __props



const to = (item: Breadcrumbs) => {
  const res = { name: item.name };
  if (item.params) {
    const params = { params: item.params };
    Object.assign(res, params);
  }
  return res;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.breadcrumbs, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "breadcrumbs_list_item"
        }, [
          (item.name)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: "breadcrumbs_list_item_link",
                to: to(item)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.label), 1)
                ]),
                _: 2
              }, 1032, ["to"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(item.label), 1))
        ]))
      }), 128))
    ])
  ]))
}
}

})